import { FC, useEffect } from 'react';
import { useAppDispatch } from '@acorn-portal/shared/src/hooks/reduxHook';
import { clearMidTermAdjustmentDetails } from '@acorn-portal/shared/src/store/midTermAdjustment.slice';
import { resetApiMTA } from '@acorn-portal/shared/src/store/midTermAdjustmentAPI.sclice';
import ChangeReferral from '../../components/change-referral';

const MtaReferralPage: FC = () => {
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(clearMidTermAdjustmentDetails());
		dispatch(resetApiMTA());
	}, [dispatch]);

	return <ChangeReferral />;
};

export default MtaReferralPage;
